export enum GenAsyncValidation {
    Email
}
